import Vue from 'vue';
import VueRouter from 'vue-router';
import userManage from '@/views/userManage/index.vue'
import deviceManage from '@/views/deviceManage/index.vue'
import deviceRenewal from '@/views/deviceRenewal/index.vue'
import store from '@/store'

Vue.use(VueRouter);

function redirectUrl() {
    const USER = localStorage.getItem("USER") ? JSON.parse(localStorage.getItem("USER")) : null;
    if (!USER) return "/login";
    return "/home";
}

//记住报表最后选中tab
function historyTag() {
    const src = "/reportCenter/"
    return src + store.state.ROUTERNAME;
}
//记住运维中心最后选中tab
function maintenanceTag() {
    const src = "/maintenance/"
    return src + store.state.MAINTENANCETAG;
}
const routes = [{
        path: "/login",
        name: "login",
        component: resolve => require(['@/views/login/index.vue'], resolve)
    },
    {
        path: "/playback",
        name: "playback",
        component: resolve => require(["@/views/playback/index.vue"], resolve)
    },
    {
        path: "/",
        name: "index",
        component: resolve => require(['@/views/index.vue'], resolve),
        meta: { requiresAuth: true },
        redirect: redirectUrl,
        children: [{
                path: "/home",
                name: "home",
                component: resolve => require(['@/views/home/index.vue'], resolve),
                meta: { requiresAuth: true },
            },
            {
                path: "/monitorCenter",
                name: "monitorCenter",
                component: resolve => require(['@/views/monitorCenter/index.vue'], resolve)
            },
            {
                path: "/playback",
                name: "playback",
                component: resolve => require(['@/views/playback/index.vue'], resolve)
            },
            {
                path: '/deviceManage',
                name: 'deviceManage',
                component: deviceManage,
            },
            {
                path: '/deviceRenewal',
                name: 'deviceRenewal',
                component: deviceRenewal
            },
            {
                path: '/userManage',
                name: 'userManage',
                component: userManage,
            },
            {
                path: "/reportCenter",
                name: "reportCenter",
                component: resolve => require(['@/views/reportCenter/index.vue'], resolve),
                redirect: historyTag,
                // redirect: "/reportCenter/offLine",
                children: [{
                        path: "/reportCenter/offLine",
                        name: "offLine",
                        component: resolve => require(['@/views/reportCenter/offLine/index.vue'], resolve)
                    },
                    {
                        path: "/reportCenter/realTimeAlarm",
                        name: "realTimeAlarm",
                        component: resolve => require(['@/views/reportCenter/realTimeAlarm/index.vue'], resolve)
                    },
                    {
                        path: "/reportCenter/commandReport",
                        name: "commandReport",
                        component: resolve => require(['@/views/reportCenter/commandReport/index.vue'], resolve)
                    },
                    {
                        path: "/reportCenter/batteryHistory",
                        name: "batteryHistory",
                        component: resolve => require(['@/views/reportCenter/batteryHistory/index.vue'], resolve)
                    },
                    {
                        path: "/reportCenter/dataReport",
                        name: "dataReport",
                        component: resolve => require(['@/views/reportCenter/dataReport/index.vue'], resolve)
                    },
                    {
                        path: "/reportCenter/permissionsLog",
                        name: "permissionsLog",
                        component: resolve => require(['@/views/reportCenter/permissionsLog/index.vue'], resolve)
                    },
                    {
                        path: "/reportCenter/alarmLog",
                        name: "alarmLog",
                        component: resolve => require(['@/views/reportCenter/alarmLog/index.vue'], resolve)
                    },
                    {
                        path: "/reportCenter/fence",
                        name: "fence",
                        component: resolve => require(['@/views/reportCenter/fence/index.vue'], resolve)
                    },
                    // {
                    //     path: "/reportCenter/track",
                    //     name: "track",
                    //     component: resolve => require(['@/views/reportCenter/track/index.vue'], resolve)
                    // },
                ]
            },
            {
                path: "/maintenance",
                name: "maintenance",
                component: resolve => require(['@/views/maintenance/index.vue'], resolve),
                redirect: maintenanceTag,
                // redirect: "/reportCenter/offLine",
                children: [
                    {
                        path: "/maintenance/remoteUpgradeFile",
                        name: "remoteUpgradeFile",
                        component: resolve => require(['@/views/maintenance/remoteUpgradeFile/index.vue'], resolve)
                    },
                    {
                        path: "/maintenance/remoteUpgradeLog",
                        name: "remoteUpgradeLog",
                        component: resolve => require(['@/views/maintenance/remoteUpgradeLog/index.vue'], resolve)
                    },
                    {
                        path: "/maintenance/driverManage",
                        name: "driverManage",
                        component: resolve => require(['@/views/maintenance/driverManage/index.vue'], resolve)
                    }
                ]
            },
        ],
    }
];

const router = new VueRouter({
    routes,
});

export default router;
